import React, { FC, useState } from 'react';
import Term from '@components/profile/modals/terms/term';
import MatchTermsVO from '@domain/vo/terms/MatchTermVO';
import { MATCH_TERMS_TYPE } from '@domain/constant/v1/termsType';
import classnames from 'classnames/bind';
import styles from './index.module.scss';

const cx = classnames.bind(styles);

const getInitialState = (status = false, length = 3) => {
  return Array.from({ length }, () => status);
};

interface ITermListProps {
  termList: MatchTermsVO[];
  checkStatus: boolean[];
  onCheck: (args: { idx: number }) => void;
}

const TermList: FC<ITermListProps> = ({ termList, checkStatus, onCheck }) => {
  // 약관 open/close 관련 작업
  const [openStatus, setOpenStatus] = useState(getInitialState());
  const getOpenStatus = (status: boolean[]) => status.every(() => false);
  const onOpen = ({ idx }: { idx: number }) => {
    const postOpenStatus = getInitialState(getOpenStatus(openStatus));

    postOpenStatus[idx] = !openStatus[idx];
    setOpenStatus(postOpenStatus);
  };

  // 백엔드 수집 동의 삭제 작업 전 까지 filter 로 처리
  return (
    <>
      {termList
        .filter(
          (term) =>
            term.type !== MATCH_TERMS_TYPE.MATCHING_EVALUATION_PROVISION &&
            term.type !== MATCH_TERMS_TYPE.MATCHING_PRIVACY_PROVISION,
        )
        .map((term, idx) => (
          <div key={term.sn} className={cx('termsWrap')}>
            <Term
              isChecked={checkStatus[idx]}
              {...term}
              onClick={() => onCheck({ idx })}
              isOpen={openStatus[idx]}
              onOpen={() => onOpen({ idx })}
            />
          </div>
        ))}
    </>
  );
};

export default TermList;
